var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36C8.0744 36 0 27.9256 0 18C0 8.0744 8.0744 0 18 0C27.9256 0 36 8.0744 36 18C36 27.9256 27.9256 36 18 36ZM18 2.25C9.31503 2.25 2.25 9.31503 2.25 18C2.25 26.685 9.31503 33.75 18 33.75C26.685 33.75 33.75 26.685 33.75 18C33.75 9.31503 26.685 2.25 18 2.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3121 23.9999C16.024 23.9999 15.7362 23.8906 15.517 23.6701L10.6421 18.7952C10.2026 18.3554 10.2026 17.643 10.6421 17.2035C11.0815 16.7641 11.794 16.7641 12.2337 17.2035L16.3135 21.2836L25.2687 12.3286C25.7082 11.8892 26.4207 11.8892 26.8601 12.3286C27.2996 12.7681 27.2996 13.4805 26.8601 13.92L17.11 23.6701C16.8881 23.8906 16.6003 23.9999 16.3121 23.9999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInCircle);
export default __webpack_public_path__ + "static/media/check-in-circle.b8f7c12e1d69339a99113d0096a5c76c.svg";
export { ForwardRef as ReactComponent };